import "./ShowcaseCard.css";

export default function ShowcaseCard({ item, className }) {
  return (
    <div className={`showcase-card ${className}`}>
      <div className="showcase-card-image">
        <img src={item.image} alt={item.alt} />
      </div>
      <div
        className="showcase-card-header"
        style={{ paddingLeft: "1.25rem", paddingRight: "1.25rem" }}
      >
        <h3 style={{ fontSize: "1.75rem", fontFamily: "Markazi Text" }}>
          {item.title}
        </h3>
        <span style={{ fontWeight: "bold", color: "#EE9972" }}>
          {item.price}
        </span>
      </div>
      <div
        className="showcase-card-body"
        style={{ paddingLeft: "1.25rem", paddingRight: "1.25rem" }}
      >
        <p style={{ margin: "0" }}>{item.description}</p>
        <span style={{ fontWeight: "bold" }}>Order a delivery</span>
      </div>
    </div>
  );
}
